

(function($, App, Utils){
  'use strict';

  var logger = new Logger('Browers');

  Utils.add('Browsers', {

    target: $(document.documentElement),

    detectedEvent: 'browser:detected',

    init: function() {
      this.browser = this.searchString(this.dataBrowser) || "Other";
      this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";

      logger.log("Browser: " + this.toString());

      this.features = this.toCssClass();

      if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
        this.features += ' standalone';
      } else {
        this.features += ' browser';
      }

      if (Utils.Browsers.is('explorer')) {
        $.getScript(App.ieHacks);
      }

      App.on(App.Events.Ready, function(e){
        Utils.Browsers.target
          .addClass(Utils.Browsers.features)
          .trigger(Utils.Browsers.detectedEvent);
      });

    },

    toString: function() {
      return this.browser + " " + this.version;
    },

    toCssClass: function() {
      return (this.browser + " " + this.browser + "-" + this.version).toLowerCase();
    },

    is: function(match) {
      return this.features.match(match) != null;
    },

    scanMobileBrowsers: function() {
      for (var i = 0; i < this.dataMobileBrowser.length; i++) {
        var dataString = this.dataMobileBrowser[i].string;
        if (dataString.indexOf(this.dataMobileBrowser[i].subString) !== -1) {
          this.versionSearchString = this.dataMobileBrowser[i].subString;
          return this.dataMobileBrowser[i].identity;
        }
      }
    },

    searchString: function(data) {
      for (var i = 0; i < data.length; i++) {
        var dataString = data[i].string;
        this.versionSearchString = data[i].subString;
        if (dataString.indexOf(data[i].subString) !== -1) {
          return data[i].identity;
        }
      }
    },

    searchVersion: function(dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index === -1) {
        return;
      }

      logger.info("Checking version against: ", dataString);

      var
        rv = dataString.indexOf("rv:"),
        ap = dataString.indexOf(this.versionSearchString);

      if (this.versionSearchString === "Trident" && rv !== -1) {

        return parseFloat(dataString.substring(rv + 3));

      } else if ( this.browser == "iOS" && ap !== -1 ) {

        var
          version = dataString.indexOf("OS "),
          ios = dataString.substring(version + "OS ".length).replace(/\_/g, '.');

        this.browser = navigator.platform + ' ' + this.browser;
        ios = ios.substring(0, ios.indexOf(" "));

        logger.info("iOS detected: ", ios);

        this.browser = this.scanMobileBrowsers() + ' ' + this.browser;

        return parseFloat(ios);

      } else if (this.browser == "Chrome" ) {

        var version = parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        var mobile = this.scanMobileBrowsers();
        this.browser = mobile ? this.scanMobileBrowsers() + ' ' + this.browser : this.browser;
        return version;

      } else {

        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      }

    },

    dataBrowser: [{
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome"
    }, {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer"
    }, {
      string: navigator.userAgent,
      subString: "Trident",
      identity: "Explorer"
    }, {
      string: navigator.userAgent,
      subString: "Edge",
      identity: "Explorer"
    }, {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox"
    }, {
      string: navigator.userAgent,
      subString: "iPad",
      identity: "iOS"
    }, {
      string: navigator.userAgent,
      subString: "iPod",
      identity: "iOS"
    }, {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iOS"
    }, {
      string: navigator.userAgent,
      subString: "Safari",
      identity: "Safari"
    }, {
      string: navigator.userAgent,
      subString: "Opera",
      identity: "Opera"
    }],

    dataMobileBrowser: [{
      string: navigator.userAgent,
      subString: "Android",
      identity: "android"
    }, {
      string: navigator.userAgent,
      subString: "CriOS",
      identity: "mobile-chrome"
    }, {
      string: navigator.userAgent,
      subString: "Version",
      identity: "mobile-safari"
    }]
  });

})(jQuery, window.App, window.App.Utils);
